import { Container } from 'pixi.js';
import { Updatable } from '../interface';

abstract class CutScene extends Container implements Updatable {
  public abstract update(elapsed: number): void;
}

export default CutScene;
